import * as Rx from 'rxjs';
import RxOp from 'rxjs-operators';
import eventStaffService from 'services/eventStaff';
import { AddSttaff, GetStaffByUserId, StaffListByEventId } from 'services/eventStaff/types';

class StaffService {
  public addStaff(data: AddSttaff): Rx.Observable<any> {
    return eventStaffService.addEventStaff(data);
  }

  public getStaffByUserId(): Rx.Observable<GetStaffByUserId> {
    return eventStaffService.getStaffByUserId().pipe(RxOp.map(response => response.data));
  }

  public staffListByEventId(eventId): Rx.Observable<StaffListByEventId> {
    return eventStaffService.staffListByEventId(eventId).pipe(RxOp.map(response => response.data));
  }

  public deleteEventStaff(eventId, staffId): Rx.Observable<any> {
    return eventStaffService.deleteEventStaff(eventId, staffId);
  }

  public resendAccessLinkEventStaff(eventId, staffId): Rx.Observable<any> {
    return eventStaffService.resendAccessLinkEventStaff(eventId, staffId);
  }
}

const staffService = new StaffService();
export default staffService;
